
<script setup>
import RequestResetPasswordForm from '@/components/RequestResetPasswordForm.vue'
</script>

<template>
  <div>
    <request-reset-password-form />
  </div>
</template>

